import { ArrowUp } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { LogoMark } from "@/components/Logo";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative overflow-hidden pt-20 pb-8 grain" data-testid="footer">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="flex items-center gap-4">
            <LogoMark className="w-14 h-14 rounded-2xl ring-1 ring-white/10" />
            <div>
              <p className="font-bold text-lg">bsys<span className="text-[#2DD4BF]">.</span></p>
              <p className="text-sm text-slate-400">{t.footer.tag}</p>
            </div>
          </div>
          <div className="flex items-center gap-6 text-sm">
            <a href="mailto:contato@bsys.ca" className="text-slate-300 hover:text-[#2DD4BF] transition-colors" data-testid="footer-email">contato@bsys.ca</a>
            <button onClick={() => window.__lenis?.scrollTo(0)} data-testid="footer-top-btn" className="inline-flex items-center gap-2 text-slate-300 hover:text-[#2DD4BF] transition-colors">
              {t.footer.top} <ArrowUp size={14} />
            </button>
          </div>
        </div>
        <p className="mt-16 select-none font-extrabold stretch-condensed uppercase leading-[0.8] tracking-tight text-[30vw] lg:text-[22vw] text-outline">
          bsys<span className="text-[#2DD4BF] [-webkit-text-stroke:0]">.</span>
        </p>
        <div className="mt-6 flex flex-col sm:flex-row justify-between gap-2 font-mono text-xs text-slate-400">
          <span>© {new Date().getFullYear()} bsys<span className="text-[#2DD4BF]">.</span> {t.footer.rights}</span>
          <span>bsys<span className="text-[#2DD4BF]">.</span> — 36</span>
        </div>
      </div>
    </footer>
  );
};
